import { Fragment } from 'react';
import { RadioGroup } from '@headlessui/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { QuestionmarkIcon } from 'views/overview/components/PortfolioInfoCard';

export interface Option {
    id: number | string;
    label: string;
    withTooltip?: boolean;
}

export interface WidgetOptions extends Option {
    startDate: string;
    endDate: string;
}

interface ButtonRadioProps<T> {
    value: T | undefined;
    options: T[];
    onChange: (option: T) => void;
}

export const ButtonRadio = <TOption extends Option>({ value, options, onChange }: ButtonRadioProps<TOption>) => {
    const { t } = useTranslation();
    return (
        <RadioGroup value={value} onChange={onChange} className='flex gap-3 items-center w-full font-medium text-normal'>
            {options.map(option => (
                <RadioGroup.Option as={Fragment} value={option} key={option.id}>
                    {({ checked }) => {
                        return (
                            <div
                                style={{
                                    border: '1px solid #E5E5E5',
                                    borderRadius: '50px',
                                    display: 'flex',
                                }}
                                className={classNames(
                                    'p-1.5 text-center grow cursor-pointer hover:bg-gray-100 focus:ring-0 d-flex justify-center items-center',
                                    {
                                        'bg-primary-100 text-white hover:bg-[#01172e] bg-[#002c5a] ': checked || option.id === value?.id,
                                    }
                                )}>
                                <span>{option.label}</span>
                                {option.withTooltip ? (
                                    <span className='ml-2 text-sm' data-tooltip-id='everything-tooltip'>
                                        <Tooltip id='everything-tooltip' content={t('from1.1.2024')} />
                                        <QuestionmarkIcon />
                                    </span>
                                ) : null}
                            </div>
                        );
                    }}
                </RadioGroup.Option>
            ))}
        </RadioGroup>
    );
};
